import { SnackbarKey, OptionsObject } from 'notistack';

interface SnackbarUtilsConfigurator {
    setEnqueueSnackbar: (
        enqueueSnackbar: (
            message: string,
            options?: OptionsObject
        ) => SnackbarKey
    ) => void;
    setCloseSnackbar: (closeSnackbar: (key: SnackbarKey) => void) => void;
}

let enqueueSnackbar: (
    message: string,
    options?: OptionsObject
) => SnackbarKey = () => '';
let closeSnackbar: (key: SnackbarKey) => void = () => {};

export const SnackbarUtilsConfigurator: SnackbarUtilsConfigurator = {
    setEnqueueSnackbar: (newEnqueueSnackbar) => {
        enqueueSnackbar = newEnqueueSnackbar;
    },
    setCloseSnackbar: (newCloseSnackbar) => {
        closeSnackbar = newCloseSnackbar;
    },
};

export const SnackbarUtils = {
    success(msg: string, options: OptionsObject = {}) {
        return enqueueSnackbar(msg, { ...options, variant: 'success' });
    },
    warning(msg: string, options: OptionsObject = {}) {
        return enqueueSnackbar(msg, { ...options, variant: 'warning' });
    },
    info(msg: string, options: OptionsObject = {}) {
        return enqueueSnackbar(msg, { ...options, variant: 'info' });
    },
    error(msg: string, options: OptionsObject = {}) {
        return enqueueSnackbar(msg, { ...options, variant: 'error' });
    },
    close(key: SnackbarKey) {
        closeSnackbar(key);
    },
};
